<template>
    <div>
        <div class="postTitle_comment_Style">
            <div class="bee_star_title">Comments
                <span class="comment_count_txt"> ({{ count }})</span>

            </div>

            <div class="postTitleStyle">
                <div :class="isNew ? 'comment_type_title' : 'comment_type_title_foce'" @click="clickType(0)">All</div>
                <div class="line_type"></div>
                <div :class="isNew ? 'comment_type_title_foce' : 'comment_type_title'" @click="clickType(1)">New</div>
            </div>
        </div>
    </div>
</template>
<script>
import { addEmit, resultEmitEvent } from "../util/event";

export default {
    name: 'commentType',
    props: {
        count: 0,
    },
    components: {},
    data() {
        return {
            isNew: false,
        }
    },

    watch: {

    },

    methods: {
        clickType(type) {
            if (type == 0) {
                this.isNew = false;
                addEmit('commentTypeListener', 0);
            } else {
                this.isNew = true;
                addEmit('commentTypeListener', 1);
            }

        },
    },

    mounted() {
        resultEmitEvent("comment_count", (res) => {
            // this.count = res;
        });
    },


}

</script>

<style scoped>
.postTitle_comment_Style {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.bee_star_title {
    font-family: SF Pro Text;
    font-size: 20px;
    font-weight: 600;
    line-height: 22px;
    text-align: left;
    color: #000;
}

.comment_count_txt {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    color: rgba(153, 153, 153, 1);
}

.postTitleStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.comment_type_title {
    font-family: SF Pro Text;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    text-align: left;
    color: #999;
    cursor: pointer;
}

.comment_type_title_foce {
    font-family: SF Pro Text;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    text-align: left;
    color: #000;
    cursor: pointer;
}

.line_type {
    border: 1px solid #E4E4E4;
    height: 19px;
    margin-left: 8px;
    margin-right: 8px;
}
</style>